var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Filters',{attrs:{"catalogs":{
      divisions: _vm.divisions,
      users: _vm.users,
    },"loading":_vm.loading,"editMode":_vm.editMode},on:{"editDivision":_vm.editDivision,"deleteDivision":_vm.deleteDivision},model:{value:(_vm.filterParams),callback:function ($$v) {_vm.filterParams=$$v},expression:"filterParams"}}),_vm._v(" "),(_vm.currentDivision.id)?_c('DivisionSchema',{attrs:{"editMode":_vm.editMode,"catalogs":{
      users: _vm.users,
    }},model:{value:(_vm.currentDivision),callback:function ($$v) {_vm.currentDivision=$$v},expression:"currentDivision"}}):_c('loading-content',{attrs:{"md-rounded":"","empty-icon":"category","empty-label":"Seleccione una división","loading":_vm.loading}}),_vm._v("\n  "+_vm._s(_vm.currentDivision)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Divisions/index.vue